import { createFileRoute } from "@tanstack/react-router";

import { BASE_COLOR } from "~/components/feature/results/components/ResultsIncome";
import { DetailPage } from "~/components/feature/shared/components/DetailPage";

export const Route = createFileRoute(
  "/_app/dashboard/results/income/$category/detail",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { category } = Route.useParams();
  return (
    <DetailPage
      tab="income"
      category={category}
      targetMetric="results"
      baseColor={BASE_COLOR}
    />
  );
}
